import { render, staticRenderFns } from "./AllBusinessAmendmentSubmissions.vue?vue&type=template&id=7df2cab3&scoped=true&"
import script from "./AllBusinessAmendmentSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllBusinessAmendmentSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllBusinessAmendmentSubmissions.vue?vue&type=style&index=0&id=7df2cab3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df2cab3",
  null
  
)

export default component.exports